import React from "react";
import { MessageCircle } from "lucide-react";
import { contactData } from "../data/mockData";

const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Olá! Gostaria de saber mais sobre os projetos de inovação do Instituto Mercosul Amazônia."
    );
    const whatsappUrl = `https://wa.me/${contactData.whatsapp.replace(/\D/g, '')}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="whatsapp-float"
      aria-label="Falar no WhatsApp"
      title="Falar conosco no WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
};

export default WhatsAppFloat;